module.exports = __webpack_public_path__ + "img/dardo-muestra-piel.8b8698bc.jpg";